/**
 * GAD Cart Group Swap
 *
 * Provides window.gadClearGroupProducts(collectionHandles, preserveVariantIds)
 *
 * Before adding a new product from a treatment group (Weight Loss or ED),
 * call this to remove any existing cart items that belong to the same group,
 * while leaving products from the other group untouched.
 *
 * @param {string[]} collectionHandles  - Array of collection handles for the group
 * @param {number[]} preserveVariantIds - Variant IDs that must never be removed (e.g. companion)
 * @returns {Promise<void>}
 */
window.gadClearGroupProducts = async function (collectionHandles, preserveVariantIds) {
  if (!collectionHandles || collectionHandles.length === 0) return;

  const preserveSet = new Set((preserveVariantIds || []).map(Number));

  // Build the full set of product IDs belonging to any of the group's collections
  const groupProductIds = new Set();
  for (const handle of collectionHandles) {
    let page = 1;
    while (true) {
      try {
        const res = await fetch(
          `/collections/${handle}/products.json?limit=250&page=${page}`,
          { headers: { Accept: 'application/json' } }
        );
        if (!res.ok) break;
        const data = await res.json();
        if (!data.products || data.products.length === 0) break;
        data.products.forEach(function (p) { groupProductIds.add(p.id); });
        if (data.products.length < 250) break;
        page++;
      } catch (e) {
        console.warn('[GAD] Could not load collection products for:', handle, e);
        break;
      }
    }
  }

  if (groupProductIds.size === 0) return;

  // Fetch current cart
  const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  if (!cart.items || cart.items.length === 0) return;

  // Build updates: set quantity to 0 for group items that are not preserved
  var updates = {};
  cart.items.forEach(function (item) {
    if (groupProductIds.has(item.product_id) && !preserveSet.has(item.variant_id)) {
      updates[item.key] = 0;
    }
  });

  if (Object.keys(updates).length === 0) return;

  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ updates: updates }),
  });
};
